import React, { useEffect } from 'react'
import { useTypedSelector } from 'src/redux/index'
import { useParams } from 'react-router-dom'
import { ActivityItem, ImageContainer, TextWrapper } from './style'
import { getUserActivitiesAction } from 'src/redux/actions/xcontest'
import { useDispatch } from 'react-redux'
import { ActivityProfile } from 'src/assets'
import { ContestModalTitle } from 'src/components/Global/Text/TitleText'
import { ContestModalWrapper } from '../About/style'

const Activity = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const { id } = params
  console.log(id)

  useEffect(() => {
    dispatch(getUserActivitiesAction({ id }))
  }, [])

  const data = useTypedSelector((state) => state.xcontest.activities)

  console.log(data)

  return (
    <ContestModalWrapper>
      <ContestModalTitle>Activities</ContestModalTitle>
      {data.map((item, index): any => {
        const { created_at, description } = item

        const date = new Date(created_at).toDateString()

        return (
          <ActivityItem key={index}>
            <ImageContainer>
              <img src={ActivityProfile} alt="" />
            </ImageContainer>
            <TextWrapper>
              <p className="description_text">{description}</p>
              <p className="date_text">{date}</p>
            </TextWrapper>
          </ActivityItem>
        )
      })}
    </ContestModalWrapper>
  )
}

export default Activity
